import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'react-router-url-params';
import { SortDirection } from '@lmt/shared-types';

export function toOffset(
  page?: any,
  perPage?: any,
  defaultPerPage = 25,
): number {
  if (!page) {
    return 0;
  }
  return (perPage ?? defaultPerPage) * page;
}

export const sortingQueryParams = (
  defaultColumn?: string,
  defaultDesc?: boolean,
) => ({
  sortBy: defaultColumn ? withDefault(StringParam, defaultColumn) : StringParam,
  desc: withDefault(BooleanParam, defaultDesc ?? false),
});
export const pagingQueryParams = (defaultPerPage: number) => ({
  page: withDefault(NumberParam, 0),
  perPage: withDefault(NumberParam, defaultPerPage),
});
export const pagingSortingQueryParams = (defaultPerPage: number) => ({
  ...pagingQueryParams(defaultPerPage),
  ...sortingQueryParams(),
});

export function toScrollQueryParams(
  queryParams: {
    skip?: number | null;
    take?: number | null;
    sortBy?: string | null;
    desc?: boolean | null;
  },
  defaultTake = 20,
) {
  return {
    pagination_Offset: queryParams.skip ?? undefined,
    pagination_Limit: queryParams.take ?? defaultTake,
    ...toSortingQueryParams(queryParams),
  };
}

export function toQueryParams(
  queryParams: {
    page?: number | null;
    perPage?: number | null;
    sortBy?: string | null;
    desc?: boolean | null;
  },
  defaultPerPage = 20,
) {
  return {
    pagination_Offset: toOffset(
      queryParams.page,
      queryParams.perPage,
      defaultPerPage,
    ),
    pagination_Limit: queryParams.perPage ?? undefined,
    ...toSortingQueryParams(queryParams),
  };
}

export function toSortingQueryParams(queryParams: {
  sortBy?: string | null;
  desc?: boolean | null;
}) {
  return {
    sorting_SortField: queryParams.sortBy,
    sorting_SortDirection: queryParams.desc
      ? SortDirection.Desc
      : SortDirection.Asc,
  };
}
